<!-- energy-dashboard.component.html -->
<div style="width: 100%;background-color: rgba(243, 246, 248, 0.495);padding-bottom: 3px;border: 2px black;" class="row">
    <div class="col-md-4" style="padding: 4px;">
      <mat-label class="device-label">Select Device</mat-label>
      <mat-select class="device-select" [(ngModel)]="selectedDevice" (selectionChange)="onDeviceSelect()">
        <mat-option  *ngFor="let dev of generatorIds" [value]="dev">
          {{ dev.digiid }} ({{ dev.sitename }})
        </mat-option>
      </mat-select>
    </div>
    <div class="col-md-4">
      <mat-label>Duration </mat-label>  
      <mat-select    [(value)]="timeFilter">
          <mat-option  *ngFor="let time of timeOptions" [value]="time"  (click)='filters(time)'>
              {{time}}
            </mat-option>
        </mat-select>
    </div>
   
</div>
    <header class="header">
      <div class="title">Energy Summary</div>
     
    </header>
  
    <section class="cards-grid">
      <!-- Energy Generated Card -->
      <article class="card large energy-card">
        <div class="card-head">
          <div>
            <div class="card-title">Energy Generated</div>
          </div>
          <mat-icon aria-hidden="false" aria-label="energy">bolt</mat-icon>
        </div>
  
        <div class="card-body">
          <div class="kpi-row">
            <div class="kpi">
              <div class="kpi-label">Active (kWh)</div>
              <div style="color: rgba(19, 135, 19, 0.863);" class="kpi-value">{{ metrics.KWH | number:'1.0-2' }}</div>
            </div>
            <div class="kpi">
              <div class="kpi-label">Apparent (kVAh)</div>
              <div style="color: orange;" class="kpi-value">{{ metrics.KVAH | number:'1.0-2' }}</div>
            </div>
            <div class="kpi">
              <div class="kpi-label">Reactive (kVARh)</div>
              <div style="color: rgba(191, 19, 19, 0.808);" class="kpi-value">{{ metrics.KVARH | number:'1.0-2' }}</div>
            </div>
          </div>
  
         <!-- <div class="mini-stats">
            <div class="stat">
              <div class="stat-label">Overall PF</div>
              <div class="stat-value highlight-blue">
                {{ metrics.PF | number:'1.2-2' }}
              </div>
            </div>
  
            <div class="stat">
              <div class="stat-label">Total Running Hours</div>
              <div class="stat-value">{{ metrics.runningHours | number:'1.0-2' }} h</div>
            </div>
  
            <div class="stat">
              <div class="stat-label">Energy Efficiency</div>
              <div class="stat-value highlight-green">
                {{ metrics.energyEfficiency | percent:'1.0-0' }}
              </div>
            </div>
          </div>
      
          <div class="progress-bar-wrap">
            <div class="progress-label">Load Factor</div>
            <div class="progress-bar">
              <div
                class="progress-fill"
                [style.width.%]="(metrics.loadFactor * 100) | number:'1.0-0'"
              ></div>
            </div>
            <div class="progress-num highlight-orange">
              {{ metrics.loadFactor | number:'1.2-2' }}
            </div>
          </div>  -->
        </div>
      </article>
  
      <!-- Fuel & Cost Card -->
      <article class="card medium fuel-card">
        <div class="card-head">
          <div class="card-title">Fuel & Cost</div>
          <mat-icon>local_gas_station</mat-icon>
        </div>
  
        <div class="card-body compact">
          <div class="fuel-row">
            <div class="fuel-item">
              <div class="fuel-label">Fuel Rate / kWh</div>
              <div class="fuel-value highlight-red">
                {{ metrics.fuelRatePerKWh | currency:'INR':'symbol':'1.2-2' }}
              </div>
            </div>
  
            <div class="fuel-item">
              <div class="fuel-label">Total Fuel Used</div>
              <div class="fuel-value">
                {{ metrics.totalFuel | number:'1.2-2' }} L
              </div>
            </div>
          </div>
  
          <div class="cost">
            <div class="cost-label">Total Cost</div>
            <div class="cost-value highlight-purple">
              {{ (metrics.totalFuel * metrics.fuelUnitPrice) | currency:'INR' }}
            </div>
          </div>
        </div>
      </article>
    </section>

      <!-- Compact KPI Cards (4 in a row) -->
      <div class="kpi-row-4">
        <article class="card small running-card">
          <div class="card-head">
            <div class="card-title">Total Running Hours</div>
            <mat-icon>schedule</mat-icon>
          </div>
          <div class="card-body center">
            <div class="kpi-value large highlight-blue">
              {{ metrics.runningHours | number:'1.0-2' }} h
            </div>
          </div>
        </article>
  
        <article class="card small fuel-rate-card">
          <div class="card-head">
            <div class="card-title">Fuel Rate / kWh</div>
            <mat-icon>attach_money</mat-icon>
          </div>
          <div class="card-body center">
            <div class="kpi-value large highlight-red">
              {{ metrics.fuelRatePerKWh | currency:'INR':'symbol':'1.2-2' }}
            </div>
            <div class="muted">Estimated</div>
          </div>
        </article>
  
        <article class="card small load-factor-card">
          <div class="card-head">
            <div class="card-title">Load Factor</div>
            <mat-icon>speed</mat-icon>
          </div>
          <div class="card-body center">
            <div class="kpi-value large highlight-orange">
              {{ metrics.loadFactor | number:'1.2-2' }}
            </div>
            <div class="muted">Better > 0.7</div>
          </div>
        </article>
  
        <article class="card small efficiency-card">
          <div class="card-head">
            <div class="card-title">Energy Efficiency</div>
            <mat-icon>insights</mat-icon>
          </div>
          <div class="card-body center">
            <div class="kpi-value large highlight-green">
              {{ metrics.energyEfficiency | percent:'1.0-0' }}
            </div>
          </div>
        </article>
      </div>
 
  